<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <div class="flex cursor-pointer">
      <input
        v-bind="field"
        type="radio"
        :id="`${name}_${value}`"
        :value="value"
        :disabled="disabled"
        class="hidden cursor-pointer"
        @change="onChange"
      />
      <label :for="`${name}_${value}`" class="radio-label flex">
        <span class="flex-1 ml-2 leading-4">
          <slot></slot>
        </span>
      </label>
    </div>

    <BaseErrorMessage v-if="errorMessage" :message="errorMessage" />
  </div>
</template>

<script>
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    BaseFormLabel,
    BaseErrorMessage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.radio-label {
  &:before {
    content: '';
    border-radius: 100%;
    @apply bg-white border w-4 h-4;
  }
  &:hover::before {
    border: 1px solid #2cb2b2;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
  }
}

input[type='radio']:checked + .radio-label {
  &:before {
    background-color: #2cb2b2;
    border: 1px solid #2cb2b2;
    box-shadow: inset 0 0 0 2px #fff;
  }
}
</style>
